export default "__VITE_ASSET__sy81Zi0P__"